/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_4_QuestionInputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_4_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Should the same choice apply to every colleague?`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_4_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有同事都应该选择同一款工具吗？`)
};

/**
* | output |
* | --- |
* | "Should the same choice apply to every colleague?" |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_4_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_7_questions_4_question = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_4_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_4_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_4_question(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_4_question(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_7_questions_4_question as "gc.search_guides.gridcraft_vs_excel.sections.7.questions.4.question" }